/** @format */

import React, { useState, useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import CardWrap from "../../Common/CardWrap";
import { useTranslation } from "react-i18next";
import { useForm, Controller } from "react-hook-form";
import iconcontentcalendar from "../../../Images/Icons/iconcontentcalendar.png";
import Select from "react-select";
import DatePicker, { registerLocale } from "react-datepicker";
import { GlobalContext } from "../../../Contexts/GlobalContextProvider";
import { globalServices } from "../../../Services/global.service";
import { productService } from "../../../Services/AccountingServices/product.service";
import { calculationService } from "../../../Services/AccountingServices/calculation.service";
import { storeService } from "../../../Services/store.service";
import ResultModal from "../../Common/ResultModal";
import AddProductModal from "../../Common/AddProductModalCalculation";
import hr from "date-fns/locale/hr";
import en from "date-fns/locale/en-US";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import cellEditFactory from "react-bootstrap-table2-editor";
import AsyncSelect from "react-select/async";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import ProductsFilterModal from "../../Common/ProductsFilterModal";
import { AuthContext } from "../../../Contexts/AuthContext";
import Tooltip from "../../Common/Tooltip";
import moment from "moment";
import { numbersAndDot } from "../../../Config/Regex";
import { roles } from "../../../Config/Roles";
registerLocale("hr", hr);
registerLocale("en", en);

const DocumentCreate = () => {
  const { selectedLanguageId } = useContext(GlobalContext);
  const { t: translator } = useTranslation();
  const history = useHistory();
  const [update, setUpdate] = useState(new Date());
  const { userId, useAccounting, roleId } = useContext(AuthContext);
  const { register, handleSubmit, errors, control, formState, setValue } =
    useForm({
      mode: "onChange",
      reValidateMode: "onChange",
    });
  const [loadModal, setLoadModal] = useState(false);
  const [values, setValues] = useState({
    storeId: 0,
    tenantId: 0,
    priceListId: 0,
  });
  const [stores, setStores] = useState([]);
  const [products, setProducts] = useState([]);
  const [showProductModal, setShowProductModal] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [modalValidationMsg, setModalValidationMsg] = useState("");
  const [partners, setPartners] = useState([]);
  const [selectedStoreId, setSelectedStoreId] = useState(0);
  const [receipts, setReceipts] = useState([]);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [quantityMsg, setQuantityMsg] = useState("");

  const [modal, setModal] = useState({
    title: "",
    text: "",
    show: false,
    btnClass: "",
  });

  const [dates, setDates] = useState({
    date: new Date(),
    startDate: "",
    endDate: "",
  });

  const onSubmit = (data) => {
    let formatedDate = new Date(
      new Date(data.date).getTime() + 8 * 60 * 60 * 1000,
    );

    let fromatedStartDate = new Date(
      new Date(data.startDate).getTime() + 8 * 60 * 60 * 1000,
    );

    let fromatedEndDate = new Date(
      new Date(dates.endDate).getTime() + 8 * 60 * 60 * 1000,
    );

    var m = moment();
    var formatedEndDate = moment(fromatedEndDate);
    m.set(formatedEndDate.toObject());

    if (products.some((e) => e.quantity === null || e.quantity <= 0)) {
      setQuantityMsg("QuantityNotNullAndNotNegative");
      return;
    }

    calculationService
      .documentCreate(
        formatedDate,
        data.storeId.id,
        data.partnerId.id,
        data.note,
        fromatedStartDate,
        formatedEndDate,
        products,
      )
      .then((res) => {
        if (res.data.success) {
          setModal({
            ...modal,
            title: "InitialState-ResultModal-CreateSuccess-Title",
            text: "InitialState-ResultModal-CreateSuccess-Text",
            show: true,
            btnClass: "btn btn-primary",
            success: true,
          });
        } else {
          setModal({
            ...modal,
            title: "InitialState-ResultModal-CreateError-Title",
            text: translator(res.data.message),
            show: true,
            btnClass: "btn btn-primary",
            success: false,
          });
        }
      })
      .catch((err) => console.log(err));
  };

  const handleClose = () => {
    setModal({ ...modal, show: false });
    if (modal.success) {
      history.push("/calculation");
    }
  };

  const handleCancel = () => {
    history.goBack();
  };

  useEffect(() => {
    if (!useAccounting) {
      history.push("/error-page/401");
    }
  }, []);

  useEffect(() => {
    console.log("PP", products);
  }, [products]);

  const promiseOptions = (inputValue) => {
    return globalServices
      .getTenantsRobno(
        Number(localStorage.getItem("tenantId")) > 0 ? userId : null,
        inputValue,
      )
      .then((res) => {
        var result = res.data.map((e) => ({
          id: e.id,
          label: e.name,
          value: e.id,
        }));
        if (Number(roleId) === roles.owner && result.length === 1) {
          const tenantId =
            Number(localStorage.getItem("tenantId")) > 0
              ? Number(localStorage.getItem("tenantId"))
              : 0;
          const tenant = result.find((x) => x.id === tenantId) || null;
          setValue("tenantId", tenant);
          handleOnChangeTenantId(tenant ? [tenant] : null);
        }

        result.unshift({
          id: 0,
          label: translator("SelectTenant-Choose"),
          value: 0,
        });
        return result;
      })
      .catch((err) => err);
  };

  function actionFormatter(cell, row) {
    return (
      <div className="action">
        <span className="icon icon-cancel" style={{ color: "#c00" }}></span>
      </div>
    );
  }
  function nameFormatter(cell, row) {
    return row.isRawMaterial ? cell + "(Sirovina)" : cell;
  }

  const options = {
    sizePerPage: 10,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
  };

  const addFilterProducts = (filterProducts) => {
    let newArr = [...products];

    //svi koji su bili izbrisani u state isActive false
    let oldDeleted = newArr.filter((ar) =>
      products.find(
        (rm) => rm.productGuid === ar.productGuid && ar.isActive === false,
      ),
    );

    //vraćam ih na isActive true
    oldDeleted.forEach((el) => (el.isActive = true));

    //ukloniti treci niz iz statea
    newArr = newArr.filter(
      (ar) => !oldDeleted.find((rm) => rm.productGuid === ar.productGuid),
    );

    //vraćamo stare kao isActive true
    newArr = newArr.concat(oldDeleted);

    let addedProducts = filterProducts.filter(
      (item) => !newArr.find((rm) => rm.productGuid === item.productGuid),
    );

    let newProducts = addedProducts.map((prod) => ({
      productGuid: prod.productGuid,
      productName: prod.productName,
      price: Number(prod.price),
      price2: prod.price,
      price3: 0,
      quantity: 0,
      tax: prod.tax,
      margin: 0,
      unitMeasureName: prod.unitMeasureName,
    }));

    newArr = newArr.concat(newProducts);
    setProducts(newArr);
  };

  const addNewProduct = (
    productGuid,
    productName,
    price,
    taxRate,
    isRawMaterial,
  ) => {
    setProducts([
      ...products,
      {
        productGuid,
        productName,
        price,
        price2: price,
        price3: price,
        quantity: 0,
        tax: isRawMaterial ? 0 : taxRate,
        margin: 0,
      },
    ]);
  };

  const GetStorePartners = (id) => {
    calculationService
      .getPartnersByStoreId(id)
      .then((res) => {
        setPartners(res.data);
      })
      .catch((err) => console.log(err));
  };

  const { SearchBar } = Search;

  const rowEvents = {
    onBlur: (e, column, columnIndex, row, rowIndex) => {
      console.log("ri", rowIndex);
      let editedPrice = products.filter((e) => e.price2 !== Number(e.price));
      if (editedPrice.length > 0) {
        setShowDatePicker(false);
      } else {
        setShowDatePicker(false);
      }
      //todo if marin change change price
    },
  };

  function currencyFormatter(cell) {
    if (typeof cell === "string" && cell.includes(",")) {
      cell = cell.replace(/,/g, ".");
    }
    return new Intl.NumberFormat("hr", {
      style: "currency",
      currency: "EUR",
    }).format(Number(cell));
  }
  function percentFormatter(cell) {
    return cell + "%";
  }

  const columns = [
    {
      dataField: "productGuid",
      text: "",
      searchable: false,
      headerStyle: (colum, colIndex) => {
        return { width: "50px", textAlign: "center" };
      },
      formatter: actionFormatter,
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => {
          setProducts(
            products.filter((item) => item.productGuid !== row.productGuid),
          );
        },
      },
    },
    {
      dataField: "productName",
      text: translator("InitialState-Product"),
      formatter: nameFormatter,
      editable: false,
    },
    {
      dataField: "unitMeasureName",
      text: translator("InitialState-UnitOfMeasure"),
      editable: false,
      searchable: false,
    },
    {
      dataField: "price3",
      text: `${translator("Nabavna cijena")}*`,
      formatter: currencyFormatter,
      searchable: false,
      validator: (newValue, row, column) => {
        setQuantityMsg("");
        if (isNaN(newValue) || newValue == "") {
          return {
            valid: false,
            message: translator("PriceNumberMsgTable"),
          };
        }
        if (newValue < 0) {
          return {
            valid: false,
            message: translator("PriceNotNegativeMsg"),
          };
        }

        if (newValue >= 1000000) {
          return {
            valid: false,
            message: translator("PriceMaxMsg"),
          };
        }

        setIsDisabled(false);
        return true;
      },
    },

    {
      dataField: "margin",
      text: `${translator("InitialState-Margin")}*`,
      searchable: false,
      formatter: percentFormatter,
      validator: (newValue, row, column) => {
        setQuantityMsg("");
        if (isNaN(newValue) || newValue == "") {
          return {
            valid: false,
            message: translator("PriceNumberMsgTable"),
          };
        }
        setIsDisabled(false);
        return true;
      },

      // events: {
      //   onClick: (e, column, columnIndex, row, rowIndex) => {
      //     console.log("margin", row.margin);
      //     console.log(
      //       "data",
      //       Number(row.price3) + Number((row.price3 * row.margin) / 100)
      //     );
      //   },
      // },
    },
    {
      dataField: "tax",
      text: `${translator("InitialState-Tax")}*`,
      formatter: percentFormatter,
      editable: false,
    },
    {
      dataField: "price",
      text: `${translator("InitialState-Price")}*`,
      formatter: currencyFormatter,
      searchable: false,
      validator: (newValue, row, column) => {
        setQuantityMsg("");
        if (isNaN(newValue) || newValue == "") {
          return {
            valid: false,
            message: translator("PriceNumberMsgTable"),
          };
        }
        if (newValue < 0) {
          return {
            valid: false,
            message: translator("PriceNotNegativeMsg"),
          };
        }

        if (newValue >= 1000000) {
          return {
            valid: false,
            message: translator("PriceMaxMsg"),
          };
        }

        setIsDisabled(false);
        return true;
      },
    },
    {
      dataField: "quantity",
      text: `${translator("InitialState-Quantity")}*`,
      searchable: false,
      validator: (newValue, row, column) => {
        if (
          isNaN(newValue) ||
          newValue == "" ||
          !numbersAndDot.test(newValue)
        ) {
          return {
            valid: false,
            message: translator("QuantityNumberMsg"),
          };
        }
        if (newValue < 0) {
          return {
            valid: false,
            message: translator("QuantityNotNegative"),
          };
        }

        if (newValue >= 100000) {
          return {
            valid: false,
            message: translator("QuantityMaxThousand"),
          };
        }
        setQuantityMsg("");
        return true;
      },
    },
  ];

  Date.prototype.addDays = function (dateOne) {
    var date = new Date(dateOne);
    date.setDate(date.getDate() + 1);
    return date;
  };

  const handleOnChangeTenantId = (event) => {
    if (!event) return;
    setValue("storeId", null, {
      shouldValidate: true,
    });
    setValue("partnerId", null, {
      shouldValidate: true,
    });

    globalServices
      .getStoresByTenantId(event[0].id)
      .then((res) => {
        setStores(res.data);
        setProducts([]);
      })
      .catch((err) => console.log(err));
    return event[0];
  };

  return (
    <>
      <CardWrap subtitle={translator("InitialState-DocumentCreate")}>
        <form onSubmit={handleSubmit(onSubmit)} className="row">
          <div className="col-lg-4">
            <fieldset className="scheduler-border">
              <legend className="scheduler-border">
                {translator("InitialState-IndexData")}
              </legend>
              <div className="form-group">
                <label>{translator("InitialState-Date")}</label>
                <div className="input-group">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="basic-addon1">
                      <img src={iconcontentcalendar} alt="calendar" />
                    </span>
                  </div>
                  <Controller
                    as={DatePicker}
                    control={control}
                    autoComplete="off"
                    className="form-control"
                    dateFormat="dd.MM.yyyy"
                    name="date"
                    showYearDropdown={true}
                    rules={{ required: true }}
                    locale={Number(selectedLanguageId) === 1 ? "hr" : "en"}
                    valueName="selected"
                    defaultValue={new Date()}
                    onChange={function ([selected]) {
                      setDates({ ...dates, date: selected });
                      return selected;
                    }}
                  />
                  {errors.date && errors.date.type === "required" && (
                    <p className="col-md-10 pl-0 text-danger">
                      {translator("ValidationMsg-RequiredField")}
                    </p>
                  )}
                </div>
              </div>
              <div className="form-group">
                <label>{translator("EditPOS-Tenant")}</label>{" "}
                <Controller
                  as={AsyncSelect}
                  control={control}
                  name="tenantId"
                  onChange={handleOnChangeTenantId}
                  placeholder={translator("Select-Tenant")}
                  defaultOptions={true}
                  loadOptions={promiseOptions}
                  rules={{
                    validate: function (value) {
                      if (!value) return false;
                      return value.value === 0 ? false : true;
                    },
                  }}
                />
                {errors.tenantId && errors.tenantId.type === "validate" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )}
              </div>
              <div className="form-group">
                <label>{translator("InitialState-Store")}</label>
                <Controller
                  as={Select}
                  options={
                    stores &&
                    stores.map((p) => ({
                      id: p.id,
                      label: p.name,
                      value: p.id,
                    }))
                  }
                  name="storeId"
                  placeholder={translator("Select-Store")}
                  rules={{
                    validate: function (value) {
                      if (!value) return false;
                      return value.value === null ? false : true;
                    },
                  }}
                  control={control}
                  onChange={function (event) {
                    setValue("partnerId", null, {
                      shouldValidate: true,
                    });
                    setSelectedStoreId(event[0].id);
                    setModalValidationMsg("");

                    storeService
                      .getById(event[0].id)
                      .then((res) => {
                        setValues({
                          storeId: event[0].id,
                          tenantId: res.data.tenantId,
                          priceListId: res.data.priceListId,
                        });
                        setProducts([]);
                        setLoadModal(true);
                      })
                      .catch((err) => console.log(err));

                    GetStorePartners(event[0].id);

                    return event[0];
                  }}
                />
                {errors.storeId && errors.storeId.type === "validate" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )}
              </div>
              <div className="form-group">
                <label>{translator("POS-New_EditPOS-Partner")}</label>
                <Controller
                  as={Select}
                  options={
                    partners &&
                    partners.map((p) => ({
                      id: p.id,
                      label: p.name,
                      value: p.id,
                    }))
                  }
                  name="partnerId"
                  placeholder={translator("Select-Store")}
                  rules={{
                    validate: function (value) {
                      if (!value) return false;
                      return value.value === null ? false : true;
                    },
                  }}
                  control={control}
                  onChange={function (event) {
                    calculationService
                      .getReceipts(selectedStoreId, event[0].id)
                      .then((res) => {
                        setReceipts(res.data);
                      })
                      .catch((err) => console.log(err));
                    return event[0];
                  }}
                />
                {errors.partnerId && errors.partnerId.type === "validate" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )}
              </div>
              <div className="form-group">
                <label>{translator("InitialState-Note")}</label>
                <textarea
                  name="note"
                  ref={register({ maxLength: 250 })}
                  className="form-control"
                  rows={4}
                  id="textArea"
                ></textarea>
                {errors.note && errors.note.type === "maxLength" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-MaxLength250")}
                  </p>
                )}
              </div>
              {showDatePicker ? (
                <>
                  <div className="form-group">
                    <label>{translator("Predisposition-DateFrom")}</label>
                    <Tooltip text={translator("PriceChange-DateFrom-Msg")} />
                    <div className="input-group">
                      <div className="input-group-prepend">
                        <span className="input-group-text" id="basic-addon1">
                          <img src={iconcontentcalendar} alt="calendar" />
                        </span>
                      </div>
                      <Controller
                        as={DatePicker}
                        control={control}
                        autoComplete="off"
                        className="form-control"
                        dateFormat="dd.MM.yyyy"
                        name="startDate"
                        showYearDropdown={true}
                        rules={{ required: true }}
                        locale={Number(selectedLanguageId) === 1 ? "hr" : "en"}
                        valueName="selected"
                        onChange={function ([selected]) {
                          setDates({ ...dates, startDate: selected });
                          return selected;
                        }}
                        minDate={new Date().addDays(dates.date)}
                      />
                      {errors.startDate &&
                        errors.startDate.type === "required" && (
                          <p className="col-md-10 pl-0 text-danger">
                            {translator("ValidationMsg-RequiredField")}
                          </p>
                        )}
                    </div>
                  </div>
                  <div className="form-group">
                    <label>{translator("Predisposition-DateTo")}</label>
                    <Tooltip text={translator("PriceChange-DateTo-Msg")} />
                    <div className="input-group">
                      <div className="input-group-prepend">
                        <span className="input-group-text" id="basic-addon1">
                          <img src={iconcontentcalendar} alt="calendar" />
                        </span>
                      </div>
                      <Controller
                        as={DatePicker}
                        control={control}
                        autoComplete="off"
                        className="form-control"
                        dateFormat="dd.MM.yyyy"
                        name="endDate"
                        showYearDropdown={true}
                        rules={{ required: true }}
                        locale={Number(selectedLanguageId) === 1 ? "hr" : "en"}
                        valueName="selected"
                        onChange={function ([selected]) {
                          setDates({ ...dates, endDate: selected });
                          return selected;
                        }}
                        minDate={new Date().addDays(dates.startDate)}
                      />
                    </div>
                  </div>
                </>
              ) : (
                ""
              )}
            </fieldset>
          </div>

          <div className="col-lg-8">
            <fieldset className="scheduler-border">
              <legend className="scheduler-border">
                {translator("InitialState-Items")}
              </legend>
              <div className="form-row">
                <Controller
                  as={Select}
                  options={
                    receipts &&
                    receipts.map((p) => ({
                      id: p.id,
                      label: p.name,
                      value: p.id,
                    }))
                  }
                  className="col-lg-5"
                  name="receiptId"
                  placeholder={translator("Select-Receipt")}
                  control={control}
                  onChange={function (event) {
                    productService
                      .getProductsByReceiptGuid(event[0].id)
                      .then((res) => {
                        let newProductsCalc = res.data.data;
                        console.log("TT", res.data.data);
                        let productsFinal = newProductsCalc.map((prod) => ({
                          productGuid: prod.productGuid,
                          productName: prod.productName,
                          price: prod.price,
                          price2: prod.price,
                          price3: prod.price2 ?? 0,
                          quantity: prod.quantity,
                          tax: prod.tax,
                          margin: prod.margin,
                          unitMeasureName: prod.unitMeasureName,
                        }));

                        setProducts(productsFinal);
                      })
                      .catch((err) => console.log(err));

                    return event[0];
                  }}
                />
                &nbsp;
                <button
                  className="btn btn-outline-secondary"
                  onClick={(e) => {
                    e.preventDefault();
                    if (document.getElementsByName("storeId")[0].value === "") {
                      setModalValidationMsg("ValidationMsg-SelectStore");
                    } else setShowFilterModal(true);
                  }}
                >
                  <span className="icon icon-filter"></span>{" "}
                  {translator("Filter")}
                </button>
                &nbsp;
                <button
                  className="btn btn-primary"
                  onClick={(e) => {
                    e.preventDefault();
                    if (document.getElementsByName("storeId")[0].value === "") {
                      setModalValidationMsg("ValidationMsg-SelectStore");
                    } else setShowProductModal(true);
                  }}
                >
                  {translator("InitialState-AddProduct")}
                </button>
                <span className="text-danger ml-2">
                  {translator(modalValidationMsg)}
                </span>
              </div>
              {update && (
                <ToolkitProvider
                  keyField="productGuid"
                  //data={products}
                  //columns={columns}
                  search
                >
                  {(props) => (
                    <>
                      <div style={{ marginTop: "20px" }} className="form-group">
                        <SearchBar
                          {...props.searchProps}
                          placeholder={translator("Search")}
                          className="col-md-12"
                        />
                      </div>

                      <hr />
                      <span className="text-danger">
                        {translator(quantityMsg)}
                      </span>
                      <BootstrapTable
                        {...props.baseProps}
                        keyField="productGuid"
                        data={products}
                        columns={columns}
                        rowEvents={rowEvents}
                        noDataIndication={translator("No-Data")}
                        pagination={paginationFactory(options)}
                        cellEdit={cellEditFactory({
                          mode: "click",
                          blurToSave: true,
                          afterSaveCell: (oldValue, newValue, row, column) => {
                            if (column.dataField == "price3") {
                              row.price3 = newValue;
                              /// 100 * (1 + 0/100) * (1 +25/100) = 125
                              /// 100 * (1 + 1/100) * (1 +25/100) = 100 * 1.01 * 1.25
                              //row.price = Number(newValue) * (1 + (row.margin / 100)) * (1 + (row.tax / 100));
                              let netPrice = row.price / (1 + row.tax / 100);
                              //130 -(130 * (25/100) / 1+(25/100)) =130 -(130 *0.25 / 1.25) = 130-26 = 104
                              //

                              row.margin = +Number(
                                ((netPrice - newValue) / newValue) * 100,
                              ).toFixed(4);
                            }

                            if (column.dataField == "margin") {
                              row.price =
                                Number(row.price3) *
                                (1 + newValue / 100) *
                                (1 + +row.tax / 100);

                              row.margin = +newValue;
                            }
                            if (column.dataField == "price") {
                              row.price = +newValue;
                              let netPrice = newValue / (1 + row.tax / 100);
                              //130 -(130 * (25/100) / 1+(25/100)) =130 -(130 *0.25 / 1.25) = 130-26 = 104
                              //

                              row.margin = +Number(
                                ((netPrice - row.price3) / row.price3) * 100,
                              ).toFixed(4);
                            }

                            setUpdate(new Date());
                          },
                        })}
                      />
                      <p>
                        <span className="editableColumns">*</span>
                        {translator("EditableTableColumns")}
                      </p>
                    </>
                  )}
                </ToolkitProvider>
              )}
            </fieldset>
          </div>
          <div
            className="container-fluid mt-4"
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <button
              className="btn btn-outline-secondary"
              onClick={handleCancel}
            >
              {translator("POS-New_EditPOS-Close")}
            </button>
            &nbsp;
            <button
              className="btn btn-primary"
              disabled={!formState.dirty}
              type="submit"
            >
              {translator("POS-New_EditPOS-Save")}
            </button>
          </div>
        </form>
      </CardWrap>
      <ResultModal
        show={modal.show}
        title={modal.title}
        text={modal.text}
        btnClass={modal.btnClass}
        handleClose={handleClose}
      />
      {loadModal && (
        <ProductsFilterModal
          show={showFilterModal}
          storeId={values.storeId}
          prodList={products}
          documentOption={1}
          handleHide={() => setShowFilterModal(false)}
          confirmAdd={addFilterProducts}
        />
      )}
      {loadModal && (
        <AddProductModal
          show={showProductModal}
          tenantId={values.tenantId}
          priceListId={values.priceListId}
          addNewProduct={addNewProduct}
          handleHide={() => setShowProductModal(false)}
          tenantTaxObligation={true}
        />
      )}
    </>
  );
};

export default DocumentCreate;
